import { frontendURL } from '../../../../helper/URLHelper';
import { REDIS_FEATURE_FLAGS } from '../../../../featureFlags';

const claudia = accountId => ({
  parentNav: 'claudia',
  routes: [
    'eddie_view',
    'eddie_view_legacy',
    'claudia_controlled_flows',
    'claudia_controlled_flows_catchall',
    'knowledge_base_view',
    'knowledge_base_view_catchall',
    'claudia_tools',
    'claudia_tools_catchall',
    'claudia_agents',
    'claudia_mcp',
    'claudia_settings',
    'claudia_deploy',
  ],
  menuItems: [
    {
      icon: 'settings',
      label: 'CLAUDIA_SETTINGS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/claudia/settings`),
      toStateName: 'claudia_settings',
      featureFlag: REDIS_FEATURE_FLAGS.CLAUDIA_SETTINGS,
    },
    {
      iconType: 'claudia',
      icon: 'file',
      label: 'CLAUDIA_CONTENT',
      hasSubMenu: false,
      key: 'claudia_content',
      toState: frontendURL(`accounts/${accountId}/claudia/knowledge-bases`),
      toStateName: 'knowledge_base_view',
      newFeatureFlag: 'enable_knowledge_bases',
    },
    {
      iconType: 'claudia',
      icon: 'coral',
      label: 'CLAUDIA_CONTROLLED_FLOWS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/claudia/eddie`),
      toStateName: 'eddie_view',
      newFeatureFlag: 'enable_flows_v2',
      hideIfFeatureFlag: true,
    },
    {
      iconType: 'claudia',
      icon: 'coral',
      label: 'CLAUDIA_CONTROLLED_FLOWS_V2',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/claudia/controlled-flows`),
      toStateName: 'claudia_controlled_flows',
      newFeatureFlag: 'enable_flows_v2',
    },
    {
      iconType: 'claudia',
      icon: 'network-alt',
      label: 'CLAUDIA_CONVERSATIONAL_AGENTS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/claudia/agents`),
      toStateName: 'claudia_agents',
      featureFlag: REDIS_FEATURE_FLAGS.CLAUDIA_AGENTS_V2,
    },
    {
      iconType: 'claudia',
      icon: 'repair-tools',
      label: 'CLAUDIA_TOOLS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/claudia/tools`),
      toStateName: 'claudia_tools',
      featureFlag: REDIS_FEATURE_FLAGS.CLAUDIA_AGENTS_V2,
    },
    {
      icon: 'cloud',
      label: 'CLAUDIA_MCP_SERVERS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/claudia/mcp`),
      toStateName: 'claudia_mcp',
      featureFlag: REDIS_FEATURE_FLAGS.CLAUDIA_AGENTS_V2,
    },
    {
      iconType: 'claudia',
      icon: 'rocket',
      label: 'CLAUDIA_DEPLOY',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/claudia/deploy`),
      toStateName: 'claudia_deploy',
      featureFlag: REDIS_FEATURE_FLAGS.CLAUDIA_DEPLOY,
    },
    {
      // Rendered as the bottom-pinned "CH Button" (orange surface) per the
      // Hub V2 sidebar Figma. Opens the Playground overlay instead of routing.
      iconType: 'fluent-v2',
      icon: 'flask-alt',
      label: 'CLAUDIA_PLAYGROUND',
      hasSubMenu: false,
      action: 'togglePlayground',
      pinnedToBottom: true,
    },
  ],
});

export default claudia;
